class CartTray {
  constructor() {
    this.tray = document.querySelector(".cart-tray");
    this.dismissTimer = null;
    if (this.tray) this.init();
  }

  init() {
    window.addEventListener("cart-tray:open", (e) => {
      this.show(e.detail?.image || null);
    });

    window.addEventListener("cart-tray:close", () => {
      this.hide();
    });

    const viewBtn = this.tray.querySelector("open-cart-drawer");
    if (viewBtn) {
      viewBtn.addEventListener("click", () => this.hide());
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.hide();
    });
  }

  show(imageSrc) {
    const wrap = this.tray.querySelector(".cart-tray-toast__img-wrap");
    if (wrap && imageSrc) {
      wrap.innerHTML = `<img src="${imageSrc}" alt="" loading="lazy">`;
    }

    this.tray.style.display = "block";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.tray.classList.add("active");
      });
    });

    clearTimeout(this.dismissTimer);
    this.dismissTimer = setTimeout(() => this.hide(), 4000);
  }

  hide() {
    this.tray.classList.remove("active");
    clearTimeout(this.dismissTimer);
    setTimeout(() => {
      this.tray.style.display = "none";
    }, 320);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new CartTray());
} else {
  new CartTray();
}
